import React from 'react';
import { useAdaptedComponents } from '../../../../hooks/useAdaptedComponents';
import { DH } from '../../../../utils/DataHook';
import { t } from '../../../../utils/i18n';
import { PaymentMethodLayout } from '../PaymentMethodLayout';
import { CommonMethodProps } from '../types';

export const InPerson: React.FunctionComponent<CommonMethodProps> = (props) => {
  const AdaptedComponents = useAdaptedComponents();

  if (AdaptedComponents) {
    return (
      <AdaptedComponents.PaymentMethodScreen
        dataHook={DH.PaymentMethod.InPerson}
      >
        <span
          data-hook={'cashier-payments-method-inPerson-content'}
          dangerouslySetInnerHTML={{
            __html: t('payments.inPerson.defaultInstructionText'),
          }}
        />
      </AdaptedComponents.PaymentMethodScreen>
    );
  }

  return (
    <PaymentMethodLayout
      dataHook={DH.PaymentMethod.InPerson}
      theme={props.theme}
    >
      <span
        data-hook={'cashier-payments-method-inPerson-content'}
        dangerouslySetInnerHTML={{
          __html: t('payments.inPerson.defaultInstructionText'),
        }}
      />
    </PaymentMethodLayout>
  );
};
InPerson.displayName = 'InPerson';
